<div
  class="searchbox-container"
  [style]="positionStyle()"
  [style.width]="width()"
>
  <mat-form-field appearance="outline" style="width: 100%">
    <mat-label>{{ label() }}</mat-label>
    @if(iconPosition()==='right'){
    <mat-icon matSuffix>search</mat-icon>
    }@else{
    <mat-icon matPrefix>search</mat-icon>
    }
    <input matInput type="text" (keyup)="emitSearchQueryChange($event)" />
  </mat-form-field>
</div>
